import { Button, CircularProgress, FormHelperText } from '@mui/material';
import { useTranslation } from 'react-i18next';

type LocationSubmitActionsProps = {
  label: string;
  disabled: boolean;
  isSubmitting: boolean;
  createDisabled: boolean;
  editDisabled: boolean;
};

export const LocationSubmitActions = ({
  label,
  disabled,
  isSubmitting,
  createDisabled,
  editDisabled,
}: LocationSubmitActionsProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <Button
        fullWidth
        size="large"
        type="submit"
        disabled={disabled || isSubmitting}
      >
        {isSubmitting ? <CircularProgress size={24} /> : label}
      </Button>
      {createDisabled && (
        <FormHelperText error sx={{ mx: 1.75 }}>
          {t('createEditLocation.errors.outsideEditableState')}
        </FormHelperText>
      )}
      {editDisabled && (
        <FormHelperText error sx={{ mx: 1.75 }}>
          {t('createEditLocation.errors.cannotEdit')}
        </FormHelperText>
      )}
    </>
  );
};
